<template>
  <div id="login">
    <Header />
    <section id="login__content">
      <BlockTitle title="会员登入" />
      <div id="login__byEmail">
        <div v-if="loginError" class="form_error"> {{ loginError }} </div>

        <label for="login_account_id" :class="{'invalid': isInValidAccountId || loginError }">
          <div class="label_title">
            帐号
            <span>*帐号错误，请再次确认</span>
          </div>
          <input type="email" id="login_account_id" v-model="account_id" @blur="handleAccountId" />
        </label>

        <label for="login_password" :class="{'invalid': isInValidPassword || loginError }">
          <div class="label_title">
            密码
            <span>*6~12个字，需英數混合</span>
          </div>
          <div class="label_input">
            <input 
              id="login_password" 
              :type="passwordType" 
              v-model="password" 
              @blur="handlePassword" 
            />
            <div class="eye" @click="handleSeePassword">
              <i :class="`icon-eye_${eyeType}`"></i>
            </div>
          </div>
        </label>

        <div class="forget_password">
          <i class="icon-password"></i>
          <div class="text" @click="goForgetPassword">忘记密码?</div>
        </div>

        <div class="btns">
          <div class="btn login" @click="handleSubmit">登入</div>
          <div class="btn register" @click="goRegister">注册</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { 
  mapGetters,
  mapActions,
} from 'vuex';

// @ is an alias to /src
import Header from "@/components/Header.vue";
import BlockTitle from "@/components/BlockTitle.vue";

export default {
  name: "home",
  components: {
    Header,
    BlockTitle
  },
  data() {
    return {
      isInValidAccountId: false,
      isInValidPassword: false,

      account_id: '',
      password: '',
      passwordType: 'password', // password, text

      redirect_uri: ''
    }
  },
  computed: {
    ...mapGetters([
      'loginError',
    ]),

    eyeType() {
      switch (this.passwordType) {
        case 'password':
          return 'close'
          break;
        case 'text':
          return 'open'
          break;
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search)

    this.redirect_uri = urlParams.get('redirect_uri')
  },
  methods: {
    ...mapActions([
      'loginByEmail',
      'resetLoginError'
    ]),
    handleAccountId() {
      if (this.account_id === '') {
        this.isInValidAccountId = true
        return 
      }

      this.isInValidAccountId = !/^[a-zA-Z0-9._]{4,}$/.test(this.account_id)
    },

    handlePassword() {
      if (this.password === '') {
        this.isInValidPassword = true
        return 
      }
      
      this.isInValidPassword = !/^(?=.*\d)(?=.*[a-zA-Z]).{6,12}$/.test(this.password)
    },

    handleSeePassword(ele) {
      this.passwordType === 'password'
      ? this.passwordType = 'text'
      : this.passwordType = 'password'
    },

    handleSubmit() {
      this.handleAccountId()
      this.handlePassword()

      if (
        this.isInValidAccountId === false &&
        this.isInValidPassword === false
      ) {
        let formData = new FormData()

        formData.append('account_id', this.account_id)
        formData.append('password', this.password)
        formData.append('redirect_uri', this.redirect_uri)

        this.loginByEmail({
          formData
        })
      }
    },

    goForgetPassword() {
      this.$router.push({ name: 'forget_password', query: {'app_id': window.app_id, 'redirect_uri': this.redirect_uri} })
    },

    goRegister() {
      this.$router.push({ name: 'register', query: {'app_id': window.app_id, 'redirect_uri': this.redirect_uri} })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.resetLoginError()

    next()
  }
};
</script>
